import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { GRID_COLUMN_GAP_XLARGE } from '@noths/polaris-client-ribbons-base';
import * as styles from "./Carousel.styles";
import { ArrowButton } from "../../elements/IconButtons/ArrowButton";
import { smoothScrollCarousel, useCarousel, useCarouselControls } from "./useCarousel";
export var Carousel = function Carousel(_ref) {
  var children = _ref.children,
    _ref$columnGap = _ref.columnGap,
    columnGap = _ref$columnGap === void 0 ? GRID_COLUMN_GAP_XLARGE : _ref$columnGap,
    forceNextItemControlEnabled = _ref.forceNextItemControlEnabled,
    forcePreviousItemControlEnabled = _ref.forcePreviousItemControlEnabled,
    onNavigateLeft = _ref.onNavigateLeft,
    onNavigateRight = _ref.onNavigateRight,
    title = _ref.title,
    _ref$titleAlignment = _ref.titleAlignment,
    titleAlignment = _ref$titleAlignment === void 0 ? 'center' : _ref$titleAlignment,
    _ref$titleSize = _ref.titleSize,
    titleSize = _ref$titleSize === void 0 ? 'regular' : _ref$titleSize;
  var itemCount = React.Children.count(children);
  var _useCarousel = useCarousel({
      itemCount,
      onNavigateLeft,
      onNavigateRight,
      columnGap,
      forcePreviousItemControlEnabled,
      forceNextItemControlEnabled
    }),
    carouselRef = _useCarousel.carouselRef,
    isSwipeNavigation = _useCarousel.isSwipeNavigation,
    showNextControl = _useCarousel.showNextControl,
    showPreviousControl = _useCarousel.showPreviousControl;
  var _useCarouselControls = useCarouselControls({
      isSwipeNavigation,
      carouselRef,
      itemCount,
      smoothScrollCarouselDI: smoothScrollCarousel,
      onNavigateLeft,
      onNavigateRight,
      columnGap
    }),
    onNext = _useCarouselControls.onNext,
    onPrevious = _useCarouselControls.onPrevious;
  var displayControls = showPreviousControl || showNextControl;
  return /*#__PURE__*/React.createElement("section", {
    "aria-labelledby": "carouselheading",
    "aria-roledescription": "carousel"
  }, /*#__PURE__*/React.createElement(_StyledHeader, {
    $_css: styles.header
  }, title && /*#__PURE__*/React.createElement(_StyledH, {
    id: "carouselheading",
    style: {
      '--titleAlignment': titleAlignment
    },
    $_css2: [styles.title, titleSize === 'regular' ? styles.titleRegular : styles.titleSmall]
  }, title), displayControls && /*#__PURE__*/React.createElement(_StyledFieldset, {
    "aria-controls": "carousel",
    "aria-label": "carousel buttons",
    $_css3: styles.controls
  }, /*#__PURE__*/React.createElement(ArrowButton, {
    "aria-label": "Scroll to previous item",
    direction: "left",
    disabled: !showPreviousControl,
    onClick: onPrevious,
    size: "small"
  }), /*#__PURE__*/React.createElement(ArrowButton, {
    "aria-label": "Scroll to next item",
    direction: "right",
    disabled: !showNextControl,
    onClick: onNext,
    size: "small"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-testid": "carousel-content",
    ref: carouselRef,
    $_css4: styles.carouselContent
  }, /*#__PURE__*/React.createElement(_StyledUl, {
    style: {
      '--columnGap': "".concat(columnGap, "px")
    },
    $_css5: styles.carouselWrapper
  }, children))));
};
var _StyledHeader = _styled("header")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledH = _styled2("h2")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledFieldset = _styled3("fieldset")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledUl = /*#__PURE__*/_styled5("ul").withConfig({
  displayName: "Carousel___StyledUl",
  componentId: "sc-yo6qe-0"
})(["", ""], function (p) {
  return p.$_css5;
});